import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=0cf5d1a0&scoped=true"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"
import style0 from "./EventView.vue?vue&type=style&index=0&id=0cf5d1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5d1a0",
  null
  
)

export default component.exports